import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { LandingsListFilters } from "@modules/landings/components";

import { useLandingsList } from "./controller";
import { useLandingsListColumns } from "./columns";

export const LandingsList = React.memo(() => {
  const {
    rows,
    agreements,
    loading,
    selectedRows,
    dataToExport,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } = useLandingsList();

  const columns = useLandingsListColumns(refetch, translate, agreements);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
              for_agreement: "",
            }}
          >
            <LandingsListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="agreements.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />
    </List>
  );
});
